import {z} from 'zod';

import type {ApiError} from 'shared/web';

const SYSTEM_USER_MODIFICATION_ERROR_CODE = 'DMS-CO-US-0013';

const systemUserModificationErrorSchema = z.object({
  status: z.literal(403),
  data: z.object({
    errors: z.array(z.object({code: z.string().nullish()})),
  }),
});

export const isSystemUserModificationError = (error?: ApiError) => {
  const result = systemUserModificationErrorSchema.safeParse(error);

  return (
    result.success &&
    result.data.data.errors.some(({code}) => code === SYSTEM_USER_MODIFICATION_ERROR_CODE)
  );
};
